import ApiService from "../ApiService";

const ForgotPasswordService = {
	reset: (forgotData) => {
		return ApiService.post('/auth/forgot-password', forgotData).catch(error => {console.log(error)});
		//@todo: for error , create a common alert box to show the errors
	}
}

export default ForgotPasswordService;